import { TFunction } from 'i18next';
import { AnchorItemKey } from '../../types';
import { AnchorItem } from './types';

export const DEFAULT_ANCHOR = `#${AnchorItemKey.GENERAL_INFORMATION}`;

export const getAnchorItems = (
  t: TFunction,
  isReconciliationSettingEnabled: boolean = false,
  isApAiServiceSettingsEnabled: boolean = false
): AnchorItem[] => {
  const items: AnchorItem[] = [
    {
      key: '1',
      title: t('anchor_item_title.general_information'),
      href: `#${AnchorItemKey.GENERAL_INFORMATION}`,
    },
    {
      key: '2',
      title: t('anchor_item_title.pic_and_contact_information'),
      href: `#${AnchorItemKey.PIC_AND_CONTACT_INFORMATION}`,
    },
    {
      key: '3',
      title: t('anchor_item_title.receiving_method'),
      href: `#${AnchorItemKey.RECEIVING_METHOD}`,
    },
  ];

  if (isReconciliationSettingEnabled) {
    items.push({
      key: '4',
      title: t('payee_reconciliation_setting'),
      href: `#${AnchorItemKey.RECONCILIATION}`,
    });
  }

  if (isApAiServiceSettingsEnabled) {
    items.push({
      key: '5',
      title: t('ai_service_setting.settings_heading'),
      href: `#${AnchorItemKey.AP_AI_SERVICE_SETTING}`,
    });
  }

  items.push({
    key: '6',
    title: t('anchor_item_title.default_payment_method'),
    href: `#${AnchorItemKey.DEFAULT_PAYMENT_METHOD}`,
    children: [
      {
        key: '7',
        title: t('anchor_item_title.payment_rule'),
        href: `#${AnchorItemKey.PAYMENT_RULE}`,
      },
      {
        key: '8',
        title: t('anchor_item_title.transaction_default_value'),
        href: `#${AnchorItemKey.TRANSACTION_DEFAULT_VALUE}`,
      },
    ],
  });

  return items;
};
